import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {getFilesApi} from '../api/files-api';
import {filesKeys} from '../query-keys';

export function useFile(id: string | undefined) {
  const tenantId = useRequiredTenantId();
  const api = getFilesApi();

  return useQuery({
    queryKey: filesKeys.files.detail(id!, tenantId),
    queryFn: async () => api.getFile(id!),
    enabled: Boolean(id),
  });
}
